module.exports = __webpack_public_path__ + "img/retail12.a9877775.png";